// Mirrors _features/billingUnits/state/slice.js's shape
// (selectedUsageSourcesFilters only, REHYDRATE normalization) - does NOT
// carry forward the old features/UsageSourcesFeature/slice.js's
// `usageSources` array mirror (write-only dead-sync - confirmed zero
// useSelector readers anywhere in the app; useUsageSourcesData already
// returns straight from the RTK Query cache) or its `customColumns`
// (also confirmed zero readers - the filters hook reads columns from
// local useState, dispatches to the slice are never read back).
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const DEFAULT_SORT = "-createdAt";

const initialState = {
  selectedUsageSourcesFilters: {
    sort: DEFAULT_SORT,
  },
};

const usageSourcesFeatureSlice = createSlice({
  name: "usageSourcesFeature",
  initialState,
  reducers: {
    updateSelectedUsageSourcesFilters: (state, action) => {
      state.selectedUsageSourcesFilters = action.payload;
    },
    resetSelectedUsageSourcesFilters: (state) => {
      state.selectedUsageSourcesFilters = {
        sort: DEFAULT_SORT,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.usageSourcesFeature) {
        const persistedData = action.payload.usageSourcesFeature;
        const persistedSort = persistedData.selectedUsageSourcesFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedUsageSourcesFilters: {
            ...(persistedData.selectedUsageSourcesFilters &&
            typeof persistedData.selectedUsageSourcesFilters === "object"
              ? persistedData.selectedUsageSourcesFilters
              : {}),
            sort: persistedSort || DEFAULT_SORT,
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedUsageSourcesFilters, resetSelectedUsageSourcesFilters } =
  usageSourcesFeatureSlice.actions;

export default usageSourcesFeatureSlice.reducer;
